import { findParentNodeClosestToPos } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

/**
 * This decoration plugin adds `dir` attribute to element except when it's in list.
 */
export const createDirectionAttributeDecorationPlugin = (targetNodeType: Node_Type) => {
  return new Plugin({
    key: new PluginKey(`${targetNodeType}-direction`),
    props: {
      decorations: ({ doc }) => {
        const decorations: Decoration[] = [];
        doc.descendants((node, pos) => {
          const $pos = doc.resolve(pos);
          const listAncestorNode = findParentNodeClosestToPos(
            $pos,
            node => node.type?.name === Node_Type.LIST_ITEM
          );
          if (listAncestorNode) {
            return false;
          }

          if (node.type.name === targetNodeType) {
            decorations.push(
              Decoration.node(pos, pos + node.nodeSize, {
                dir: 'auto',
              })
            );
          }
        });
        return DecorationSet.create(doc, decorations);
      },
    },
  });
};
